import { Container } from "react-bootstrap";
import { ThemeProvider } from "styled-components";
import useTheme from "../../hook/useTheme";
import { AutoagendamientoV2Styles } from "../../theme/AutoagendamientoV2Styles";
import HeaderTop from "../../components/autoagendamientov2/HeaderTop";
import MexForm from "../../components/autoagendamientov2/mexico/MexForm";
import AutoagendmientoFooter from "../../components/autoagendamientov2/AutoagendmientoFooter";
import Banner1 from "../../components/autoagendamientov2/Banner1";
import Banner2 from "../../components/autoagendamientov2/Banner2";
import ConfirmarServicio from "../../components/autoagendamientov2/ConfirmarServicio";
import MexEspecialidad from "../../components/autoagendamientov2/mexico/MexEspecialidad";
import TiempoValidez from "../../components/autoagendamientov2/TiempoValidez";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useState } from "react";
import Loading from "../../components/autoagendamientov2/Loading";
import SockJsClient from "react-stomp";
import {
  BASE_URL_WS,
  GET_LINK_PATIENT_AUTOAGENDAMIENTO,
  SAVE_LINK_PATIENT_AUTOAGENDAMIENTO,
} from "../../api/Routes";
import CardDinamic from "../../components/autoagendamientov2/CardDinamic";
import { useEffect } from "react";
import Get from "../../api/Get";
import {
  initColombusA,
  initData,
  initEps,
} from "../../components/autoagendamientov2/data/contants";
import moment from "moment";
import { convertSource } from "../../utils/convertSource";
import Post from "../../api/Post";
import ClbForm from "../../components/autoagendamientov2/colombia/ClbForm";
import ClbEspecialidad from "../../components/autoagendamientov2/colombia/ClbEspecialidad";
import ClbConfirmarServicio from "../../components/autoagendamientov2/colombia/ClbConfirmarServicio";
import {FinalizarAutoAgendamiento} from "./FinalizarAutoAgendamiento";
import {IkeNowUrl} from "../../utils/ikeNowUrl";
import {useWalmartUrl} from "../../utils/walmartUrl";

function AutoagendamientoV2() {
  const { theme } = useTheme("defaultv2");
  const { id } = useParams();
  const [currentScreen, setCurrentScreen] = useState("loading");
  const [currentBanner, setCurrentBanner] = useState("");
  const [dataHelp, setDataHelp] = useState({
    patient: null,
    validLink: true,
    startMeeting: null,
    currentTime: null,
    clientTime: Date.now(),
    reservadoExitosamente: false,
    isPedienteAprobacion: false,
    notEdit: false,
    fieldSettings: [],
    declined: false,
    source: "autoagendamientocat",
    configuration: null,
    payment: null,
    paymentStatus: "currentflow",
    linkAllianz: true,
  });
  //configuration account data(styles and data to the steps realted to the account)
  const [configuration, setConfiguration] = useState(null);
  //payments
  const [payment, setPayment] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState("currentflow");
  const ikeNow = IkeNowUrl()
  const { isWalmart } = useWalmartUrl()

  const onComplete = async () => {
    setCurrentScreen("loading");
    let d = {
      id: atob(id),
      active: false,
    };
    try {
      await Post({
        url: SAVE_LINK_PATIENT_AUTOAGENDAMIENTO,
        data: d,
        header: false,
      });
      setCurrentScreen("timeOver");
    } catch (error) {}
  };

  const screens = {
    loading: (
      <div className="p-5 text-center">
        <Loading />
      </div>
    ),
    linkObsolote: <CardDinamic children={linkObsolete}></CardDinamic>,
    mexFormPatient: (
      <>
        <TiempoValidez
          classTop="mt--20"
          data={dataHelp}
          onComplete={onComplete}
        />
        <MexForm
          data={dataHelp}
          setData={setDataHelp}
          setCurrentScreen={setCurrentScreen}
        />
      </>
    ),
    mexEspecialidad: (
      <>
        <TiempoValidez
          classTop="mt--20"
          data={dataHelp}
          onComplete={onComplete}
        />
        <MexEspecialidad
          data={dataHelp}
          setData={setDataHelp}
          setCurrentScreen={setCurrentScreen}
        />
      </>
    ),
    mexReservadoOK: (

        <>
            {ikeNow ? (
              <FinalizarAutoAgendamiento data={dataHelp}/>
            ) : (
              <CardDinamic children={mexReservadoOKContent(isWalmart)} />
            )}
        </>

        // <CardDinamic children={mexReservadoOK}></CardDinamic>
    ),
    clbFormPatient: (
      <>
        <TiempoValidez
          classTop="mt--20"
          data={dataHelp}
          onComplete={onComplete}
        />
        <ClbForm
          data={dataHelp}
          setData={setDataHelp}
          setCurrentScreen={setCurrentScreen}
          setConfiguration={setConfiguration}
        />
      </>
    ),
    clbEspecialidad: (
      <>
        <TiempoValidez
          classTop="mt--20"
          data={dataHelp}
          onComplete={onComplete}
        />
        <ClbEspecialidad
          data={dataHelp}
          setData={setDataHelp}
          setCurrentScreen={setCurrentScreen}
        />
      </>
    ),
    clbConfirmarServicio: (
      <>
        <TiempoValidez
          classTop="mt--20"
          data={dataHelp}
          onComplete={onComplete}
        />
        <ClbConfirmarServicio
          data={dataHelp}
          setData={setDataHelp}
          setCurrentScreen={setCurrentScreen}
          configuration={configuration}
          setPayment={setPayment}
          setPaymentStatus={setPaymentStatus}
        />
      </>
    ),
    declinadoConsentimientoTLS: (
      <CardDinamic children={declinadoConsentimientoTLS}></CardDinamic>
    ),
    confirmarServicio: (
      <>
        <TiempoValidez
          classTop="mt--20"
          data={dataHelp}
          onComplete={onComplete}
        />
        <ConfirmarServicio
          data={dataHelp}
          setData={setDataHelp}
          setCurrentScreen={setCurrentScreen}
        />
      </>
    ),
    timeOver: <CardDinamic children={timeOver}></CardDinamic>,
    DECLINED: <CardDinamic children={buttonReload}></CardDinamic>,
    PENDING: <CardDinamic children={buttonPending}></CardDinamic>,
    PAID: <CardDinamic children={buttonPaid}></CardDinamic>,
    failPayment: <CardDinamic children={buttonFailPayment}></CardDinamic>,
    reservadoNoCopayment: (
      <CardDinamic children={reservadoNoCopayment(configuration)}></CardDinamic>
    ),
  };
  const banners = {
    banner1: <Banner1 />,
    banner2: <Banner2 />,
  };

  useEffect(() => {
    if (
      currentScreen === "mexFormPatient" ||
      currentScreen === "clbFormPatient"
    ) {
      setCurrentBanner("banner2");
    } else if (
      currentScreen === "mexEspecialidad" ||
      currentScreen === "confirmarServicio" ||
      currentScreen === "clbEspecialidad" ||
      currentScreen === "clbConfirmarServicio"
    ) {
      setCurrentBanner("banner1");
    } else {
      setCurrentBanner("");
    }
  }, [currentScreen]);

  //get Patient from link autoagendamiento
  useEffect(() => {
    const fecthPatient = async () => {
      try {
        const response = await Get({
          url: `${GET_LINK_PATIENT_AUTOAGENDAMIENTO}/${id}`,
          noToken: true,
        });
        if (response.data.state) {
          console.log(response.data.data);
          let data = response.data.data;
          const validLink = validateLink(
            data.active,
            data.currentServerTime,
            data.duration,
            data.serverTime
          );
          if (!validLink) {
            setCurrentScreen("linkObsolote");
            return;
          }
          let colombusA = { ...initColombusA };
          if (data.patient.colombusAddress) {
            colombusA.id = data.patient.colombusAddress.id;
            colombusA.roadType = data.patient.colombusAddress.roadType
              ? data.patient.colombusAddress.roadType
              : null;
            colombusA.streetField1 = data.patient.colombusAddress.streetField1;
            colombusA.streetField2 = data.patient.colombusAddress.streetField2;
            colombusA.streetField3 = data.patient.colombusAddress.streetField3;
            colombusA.propertyNumber =
              data.patient.colombusAddress.propertyNumber;
            colombusA.propertyType = data.patient.colombusAddress.propertyType
              ? data.patient.colombusAddress.propertyType
              : null;
            colombusA.propertyTypeAdditional = data.patient.colombusAddress
              .propertyTypeAdditional
              ? data.patient.colombusAddress.propertyTypeAdditional
              : null;
            colombusA.unitNumber = data.patient.colombusAddress.unitNumber;
          }
          let epsObj = { ...initEps };
          if (data.patient.eps) {
            epsObj.id = data.patient.eps.id;
            epsObj.nombreEps = data.patient.eps.nombreEps;
            epsObj.codigo = data.patient.eps.codigo;
          }
          setDataHelp((prev) => ({
            ...prev,
            patient: {
              ...initData,
              id: data.patient.id,
              name: data.patient.name.toUpperCase(),
              middleName: data.patient.middleName
                ? data.patient.middleName.toUpperCase()
                : "",
              seccondSurname: data.patient.seccondSurname
                ? data.patient.seccondSurname.toUpperCase()
                : "",
              lastName: data.patient.lastName.toUpperCase(),
              gender: data.patient.gender,
              dateOfBirthday: data.patient.dateOfBirthday
                ? new Date(moment(data.patient.dateOfBirthday, "DD-MM-YYYY"))
                : "",
              nationality: data.patient.nationality
                ? data.patient.nationality
                : "",
              phoneNumber: data.patient.phoneNumber
                ? data.patient.phoneNumber
                : "",
              phoneNumber2: data.patient.phoneNumber2
                ? data.patient.phoneNumber2
                : "",
              email: data.patient.email,
              bloodType: data.patient.bloodType ? data.patient.bloodType : "",
              ocupacion: data.patient.ocupacion
                ? data.patient.ocupacion.id
                : "",
              address: data.patient.address ? data.patient.address : "",
              externalId: data.patient.externalId
                ? data.patient.externalId
                : "",
              account: data.patient.account,
              company: data.patient.company,
              currentInsurance: data.patient.currentInsurance,
              aceptarTerminos: true,
              linkPatient: data.id,
              localidad: data.patient.localidad
                ? data.patient.localidad
                : { id: "" },
              neighborhood: data.patient.neighborhood
                ? data.patient.neighborhood
                : "",
              identityDocumentType: data.patient.identityDocumentType
                ? data.patient.identityDocumentType
                : {
                    id: "",
                    name: "",
                    code: "",
                  },
              documentNumber: data.patient.documentNumber
                ? data.patient.documentNumber
                : "",
              country: data.patient.country ? data.patient.country.id : "",
              municipio: data.patient.municipio
                ? data.patient.municipio.id
                : null,
              state: data.patient.state ? data.patient.state.id : null,
              expediente: data.expediente ? data.expediente : "",
              patientRelationship: data.patient.patientRelationship
                ? data.patient.patientRelationship.id
                : "",
              colombusAddress: colombusA,
              countryBirth: data.patient.countryBirth
                ? data.patient.countryBirth.id
                : "",
              eps: epsObj,
            },
            source: data.source ? convertSource(data.source) : dataHelp.source,
            notEdit: data.source !== 8 ? true : false,
            isPedienteAprobacion: data.patient.account
              ? !data.patient.account.automaticValidation
              : false,
          }));

          if (data.patient?.company?.id === 1) {
            setCurrentScreen("mexFormPatient");
          } else if (data.patient?.company?.id === 2) {
            setCurrentScreen("clbFormPatient");
          }
        }
        //console.log(response)
      } catch (error) {
        console.log(error);
      }
    };
    fecthPatient();
  }, []);

  const validateLink = (active, currentTimeServer, mDuration, dateCreated) => {
    if (!active) {
      setDataHelp((prev) => ({
        ...prev,
        validLink: false,
      }));
      return false;
    }
    let currentTS = moment(currentTimeServer, "DD/MM/YYYY HH:mm:ss");
    let fechaValidez = moment(dateCreated, "DD/MM/YYYY HH:mm").add(
      mDuration,
      "minutes"
    );
    setDataHelp((prev) => ({
      ...prev,
      currentTime: currentTS.toDate().getTime(),
      startMeeting: fechaValidez,
    }));
    if (currentTS.isAfter(fechaValidez)) {
      setDataHelp((prev) => ({
        ...prev,
        validLink: false,
      }));
      return false;
    }
    return true;
  };

  //checar payment status
  useEffect(() => {
    if (paymentStatus === "DECLINED") {
      setCurrentScreen("DECLINED");
    } else if (paymentStatus === "PENDING") {
      setCurrentScreen("PENDING");
    } else if (paymentStatus === "PAID") {
      setCurrentScreen("PAID");
    }
  }, [paymentStatus]);

  const handleMessageSocket = (message) => {
    setPaymentStatus(message);
  };

  return (
    <ThemeProvider theme={theme}>
      <AutoagendamientoV2Styles />
      <div className="body-1">
        <HeaderTop company={dataHelp?.patient?.company} />
        {banners[currentBanner]}
        <main>
          <Container>{screens[currentScreen]}</Container>
        </main>
        <AutoagendmientoFooter
          configuration={configuration}
          cita={{ account: dataHelp?.patient?.account }}
        />
      </div>
      {payment && (
        <SockJsClient
          url={`${BASE_URL_WS}/ws`}
          topics={[`/user/${payment.id}/queue/paymentStatus`]}
          onMessage={(message) => handleMessageSocket(message)}
        />
      )}
    </ThemeProvider>
  );
}

export default AutoagendamientoV2;

export const linkObsolete = (
  <div>
    <p className="text-center m-0 py-2">
      Esta liga ya se ha usado, no es posible usarla para concluir tu solicitud.
      Gracias.
    </p>
  </div>
);
const timeOver = (
  <div>
    <p>
      Se ha terminado el tiempo para agendar su cita. Si desea otra cita
      comuniquese con nosotros. Gracias.
    </p>
  </div>
);
export const mexReservadoOKContent = (hideFinalizar = false) => (
  <div>
    <p>
      Sr (a). Usuario: Gracias por agendar su cita con nosotros. Recibirá la
      confirmación en la brevedad posible mediante mensaje de texto y correo
      electrónico (verifique la bandeja de correo no deseado)
    </p>
    {!hideFinalizar && (
      <button
        onClick={() => {
          //window.open("about:blank", "_self");
          //window.close();
          window.location.reload();
        }}
      >
        Finalizar
      </button>
    )}
  </div>
);
export const mexReservadoOK = mexReservadoOKContent(false);
export const declinadoConsentimientoTLS = (
  <div>
    <p>
      Usted ha declinado el{" "}
      <strong>CONSENTIMIENTO INFORMADO PARA EL SERVICIO DE TELESALUD </strong>
      por lo que no puede acceder a dicha cita. Si desea agendar nueva cita por
      favor realizar nuevamente su proceso de agendamiento.
    </p>
  </div>
);
export const buttonReload = (
  <div>
    <p>
      Sr(a). Usuario: Su cita no pudo ser agendada. El tiempo para realizar el
      pago de la cita se ha agotado o su pago no fue aprobado, en caso de
      necesitar el agendamiento de la cita por favor realice de nuevo el
      proceso. Gracias
    </p>
    {/* <button onClick={() => window.location.reload()}>Iniciar proceso</button> */}
  </div>
);
export const buttonPending = (
  <div>
    <p>
      Sr(a). Usuario: Su cita está en proceso de pago. Recuerde que tiene 15
      minutos para realizar el pago, de lo contrario, su cita no será agenda y
      deberá repetir el proceso de agendamiento. Gracias
    </p>
  </div>
);
export const buttonPaid = (
  <div>
    <p>
      Sr (a). Usuario: su cita fue pagada con éxito, su servicio se encuentra en
      proceso de aprobación. Recibirá la confirmación en la brevedad posible
      mediante mensaje de texto y correo electrónico (verifique la bandeja de
      correo no deseado) Para cancelar su cita comuníquese con nosotros.
    </p>
    <button
      onClick={() => {
        //window.open("about:blank", "_self");
        //window.close();
        window.location.reload();
      }}
    >
      Finalizar
    </button>
  </div>
);
export const buttonFailPayment = (
  <div>
    <p>
      Sr(a). Usuario: Su cita no pudo ser agendada, por favor realice nuevamente
      el proceso de agendamiento. Gracias
    </p>
    {/* <button onClick={() => window.location.reload()}>Iniciar proceso</button> */}
  </div>
);
export const reservadoNoCopayment = (configuration) => (
  <div>
    <h5>Tu servicio está en proceso de aprobación</h5>
    <p>{configuration?.approvedServiceText ?? ""}</p>
    <button
      onClick={() => {
        //window.open("about:blank", "_self");
        //window.close();
        window.location.reload();
      }}
    >
      Finalizar
    </button>
  </div>
);
